import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from 'src/app/core/constants';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';
import { UpdateProposalPhysicalInspectionDTO } from 'src/app/models/internal/update-proposal-physical-inspection-dto';
import { DataService } from 'src/app/services/data.service';
import { FormService } from 'src/app/services/form';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { ProposalImage } from 'src/app/models/proposal-image';
import { ImageToBeDeleted } from 'src/app/models/internal/image-tobe-deleted';
import { ProposalService } from 'src/app/services/proposal.service';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';

@Component({
  selector: 'app-physicalinspection',
  templateUrl: './physicalinspection.component.html',
  styleUrls: ['./physicalinspection.component.scss']
})
export class PhysicalinspectionComponent implements OnInit {
  @Input() ProposalId: number;
  @Input() IsSupplier: boolean;
  @Input() isUpdateMode: boolean;
  physicalInspectionImages: ProposalImage[] = [];
  @Output() private newInspectionImageUploaded: EventEmitter<
  FormFileToBeUploaded
> = new EventEmitter<FormFileToBeUploaded>();
@Output() private imageDeleteClicked: EventEmitter<
        ImageToBeDeleted
    > = new EventEmitter<ImageToBeDeleted>();
physicalinspectionForm: FormGroup;
  isPhysicalInspectionComplete: any[] = [];
  isPhysicalInspectionPassed: any[] = [];
  RejectionCommentRequired = false;
  public formErrors = {
    isPhysicalInspectionComplete: '',
    isPhysicalInspectionPassed: '',
    rejectionComment: '',
  };
  IsLatestActiveProposal: boolean;
  constructor(
    public FormService: FormService,
    private dataService: DataService,
    private proposalService: ProposalService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private router: Router
    ) {
    this.physicalinspectionForm = this.fb.group({
      isPhysicalInspectionComplete: [null],
      isPhysicalInspectionPassed: [null],
      rejectionComment: [null]
    });

    this.isPhysicalInspectionComplete.push({'Description': 'Yes', 'Value': 1});
    this.isPhysicalInspectionComplete.push({'Description': 'No', 'Value': 0});
    this.isPhysicalInspectionPassed.push({'Description': 'Yes', 'Value': 1});
    this.isPhysicalInspectionPassed.push({'Description': 'No', 'Value': 0});

  }

  ngOnInit() {
    this.proposalService.createProposalDTO.subscribe(prop => {
      if (prop) {
          this.IsLatestActiveProposal = prop.DefaultProposal.IsLatestActiveProposal;
          this.setControlValues(prop);
          this.physicalInspectionImages.forEach(x => {
              this.dataService.getImageFile(x.Id.toString()).subscribe((y: any) => {
                if (y['Success'] == true) {
                  const extension = String(y['Data']['FileName']).split('.');
                  if (extension.length >= 2) {
                      x.DisplayUrl = 'data:image/' + extension[extension.length - 1] + ';base64,' + y['Data']['Base64String'];
                  } else {
                      x.DisplayUrl = 'data:image/png' + ';base64,' + y['Data']['Base64String'];
                  }
                }
              });
            });
      }
  });
  }
  setControlValues(prop: CreateProposalDTO) {
    {
        this.ProposalId = prop.DefaultProposal.ProposalId;
        if (
            prop.DefaultProposal.ImageInfo &&
            prop.DefaultProposal.ImageInfo.length > 0
        ) {
            this.physicalInspectionImages = prop.DefaultProposal.ImageInfo.filter(
                a => a.Type == 3
            );
        } else if (
            prop.DefaultProposal.ImageInfo &&
            prop.DefaultProposal.ImageInfo.length == 0
        ) {
            this.physicalInspectionImages = [];
        }
    }
}
  savePhysicalInspectionResult() {
    const isInspectionPassed = this.physicalinspectionForm.get('isPhysicalInspectionPassed').value;
    const rejectionComment = this.physicalinspectionForm.get('rejectionComment').value;
    if (isInspectionPassed == 0  &&  !rejectionComment) {
      this.RejectionCommentRequired = true;
      return;
    } else {
      this.RejectionCommentRequired = false;
    }
    this.ValidateForm();
    if (this.physicalinspectionForm.valid) {
      const updateProposalPhysicalInspectionDTO: UpdateProposalPhysicalInspectionDTO = new UpdateProposalPhysicalInspectionDTO();
      updateProposalPhysicalInspectionDTO.ProposalId = this.ProposalId;


      updateProposalPhysicalInspectionDTO.UserBypassedActiveProposalWarning = false;
      if (this.IsLatestActiveProposal && !isInspectionPassed) {
          if(!confirm("This is the latest active proposal for this part number. Rejecting the proposal would mean that we will not have any valid packaging proposal for MRP or TMS to use for FOQ selection and shipment optimization. If the dimension, weight and QPC are correct but you want the supplier to update some other information, then you can mark it 'Incomplete', so that it will show up in supplier's queue and they can fix it. Supplier will also get chargeback if they do not comply. Do you still want to reject the proposal?")){
              return; 
          } else {
              updateProposalPhysicalInspectionDTO.UserBypassedActiveProposalWarning = true;
          }
      }
      updateProposalPhysicalInspectionDTO.IsPhysicalInspectionPass = isInspectionPassed;
      updateProposalPhysicalInspectionDTO.RejectionComment = rejectionComment;
      this.dataService
          .UpdateProposalPhysicalInspectionStatus(updateProposalPhysicalInspectionDTO)
          .subscribe((response: any) => {
              // this.partInfo = response
              if (response != null) {
                this.toastService.success(
                  'Physical Inspection status ' + Constants.SUCCESS_SAVE_GENERIC
              );
              this.router.navigate(['/PendingInspectionProposals']);
              }
          });
    }

  }
  imageUploaded(imageToBeUploaded: FormFileToBeUploaded) {
    // debugger;
    this.newInspectionImageUploaded.emit(imageToBeUploaded);
}
getImageURL(image: ProposalImage) {
      if (image.DisplayUrl == undefined || image.DisplayUrl == null || image.DisplayUrl === '') {
          return image.UUId;
      } else {
          return image.DisplayUrl;
      }
}

imageDelete(imageToBeDeleted: ImageToBeDeleted) {
  this.imageDeleteClicked.emit(imageToBeDeleted);
}

  ValidateForm() {
    this.formErrors = this.FormService.validateForm(
        <FormGroup>this.physicalinspectionForm,
        this.formErrors
    );
}

}
